import * as React from "react"
import {Place} from "../model/places/PlaceTypes"
import {DirectionsMap, MapContainerStyle} from "./DirectionsMap"
import {ID} from "../model/id"
import {Locale} from "../model/BookingTypes"
import {BookingFormJourneyState} from "../state"
import {Place as PLACE} from "../graphql/queries"
import {GraphQL} from "../graphql"

interface OwnProps {
  placeId: ID
  locale: Locale
}

type Props = OwnProps & PlaceProp

function PlaceMap(props: Props) {
  const {locale, place} = props

  const journey: BookingFormJourneyState = {
    origin: place,
    destination: null,
    waypoints: [],
  }

  const containerStyle: MapContainerStyle = {
    height: "100%",
    width: "93%",
  }

  return (
    <DirectionsMap
      journey={journey}
      locale={locale}
      onOptimizedWaypoints={null}
      zoom={15}
      containerStyle={containerStyle}
    />
  )
}

interface PlaceProp {
  place: Place | null
}

function WithPlace(props: OwnProps) {
  const {placeId} = props
  return (
    <GraphQL.Query
      query={PLACE}
      variables={{id: placeId}}
      render={({data}) => {
        if (data) {
          return <PlaceMap {...props} place={data.place} />
        } else {
          return null
        }
      }}
    />
  )
}

export {WithPlace as PlaceMap}



// WEBPACK FOOTER //
// ./src/components/PlaceMap.tsx